<script setup lang="ts">

</script>

<template>
  <div :class="$style.form">
    <slot />
  </div>
</template>

<style lang="scss" module>
  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12rem;
    height: 100vh;
  }
</style>
